export const PagingField = {
  Filter: 'filter',
  SortColumn: 'sortColumn',
};

export const defaultSort = [
  { id: 'LastName', desc: false },
  { id: 'FirstName', desc: false },
];



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/helpers/constants.js